import styled from 'styled-components'
import React from 'react';

import { 
  Text,
} from '../reusable/Other'
import Icon from '../reusable/Icon'


const CopyInput = ({ clicked, toggleClicked, text, iconColor, iconWidth, iconHeight }) => {

  return(
    <Wrap height={iconHeight}>
      <CopiedIndicator clicked={clicked}><Text>Copied!</Text></CopiedIndicator>
      <Icon 
        onClick={()=>{
          window.navigator.clipboard.writeText(text);
          toggleClicked(false);
          setTimeout(()=>toggleClicked(true),10)
        }} 
        icon="copy"
        width={iconWidth}
        height={iconHeight}
        color={iconColor}
      />
    </Wrap>
  )
}

export default CopyInput


const Wrap = styled.div(props => ({
  position:"relative",
  height: props.height,
}));

const CopiedIndicator = styled.div(props => ({
  background:"#fff",
  borderRadius:10,
  position:"absolute",
  zIndex:-1,
  transition:props.clicked ? "top 1s ease-out, opacity 0.2s ease-out 0.8s" : "0s",
  right:0,
  top:props.clicked ? -36 : -10,
  opacity:props.clicked ? 0 : 1,
  width:50,
  padding:"0px 5px",
}));
